// Prod_US session: puts the signed-in phone user and their one person where the existing
// app code already looks, so PersonDashboard, the test screens and the uploads work unchanged.
//   mmtSession (local + session storage) .accessToken  <- Firebase ID token (kept fresh)
//   sessionStorage access_token                         <- same token (read first by v5Api.js)
//   sessionStorage staffDetails                         <- { id, customer_type: "prod_us" } (terminology, module rules)
//   sessionStorage userList / userIndex                 <- [person], 0 (userInfoFetch)
import {
  clearStoredSession,
  getStoredSession,
  setStoredSession,
  CLIENT_INOCHI,
} from "../mmtUserList/mmtFlow";
import { PERSON_DASHBOARD } from "../../routes/routerPath";
import { PROD_US_CUSTOMER_TYPE } from "./prodUsConfig";
import { onTokenChange } from "./firebasePhoneAuth";

export const isProdUsSession = (session = getStoredSession()) =>
  session?.customer_type === PROD_US_CUSTOMER_TYPE;

export const storeToken = (token) => {
  const session = getStoredSession();
  if (!token || !isProdUsSession(session)) return;
  setStoredSession({ ...session, accessToken: token });
  sessionStorage.setItem("access_token", token);
};

// Every API client reads the stored token, so it must follow Firebase's hourly refresh for
// as long as the page is open, whichever screen is showing. Hence never unsubscribed.
let keepingTokenFresh = false;
export const keepTokenFresh = () => {
  if (keepingTokenFresh) return;
  keepingTokenFresh = true;
  onTokenChange((token) => storeToken(token));
};

export const storeProdUsSession = (token, me) => {
  const appUser = me?.app_user || {};
  setStoredSession({
    accessToken: token,
    staffId: appUser.id,
    client: CLIENT_INOCHI,
    locale: "en",
    customer_type: PROD_US_CUSTOMER_TYPE,
    authProvider: "firebase",
  });
  sessionStorage.setItem("access_token", token);
  sessionStorage.setItem(
    "staffDetails",
    JSON.stringify({ id: appUser.id, customer_type: PROD_US_CUSTOMER_TYPE }),
  );
  if (me?.person) storeProdUsPerson(me.person);
};

export const storeProdUsPerson = (person) => {
  sessionStorage.setItem("userList", JSON.stringify([person]));
  sessionStorage.setItem("userIndex", "0");
};

export const clearProdUsSession = () => {
  clearStoredSession();
  sessionStorage.removeItem("access_token");
  sessionStorage.removeItem("staffDetails");
  sessionStorage.removeItem("measurementUploadSession");
};

// The person page, Metrics tab, no bottom bar. No token in the URL: it would go stale after
// an hour, and the app reads the fresh one from storage when the URL has none.
export const personPagePath = (person) => {
  const session = getStoredSession() || {};
  const query = new URLSearchParams({
    staffId: session.staffId || "",
    client: CLIENT_INOCHI,
    locale: "en",
    tab: "metrics",
    hideNav: "true",
    seniorId: person?.id || "",
    seniorUuid: person?.id || "",
  });
  return `${PERSON_DASHBOARD}?${query.toString()}`;
};
